import { render, staticRenderFns } from "./baseStructure.vue?vue&type=template&id=3b304951&scoped=true"
import script from "./baseStructure.vue?vue&type=script&lang=js"
export * from "./baseStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b304951",
  null
  
)

export default component.exports